import config from '@/const/config';
import createInstance from '../http';
const { request } = createInstance(config.orderBaseUrl);

// const BUSINESS_PATH_PREFIX = `http://118.24.69.110:7300/mock/62fb3b14f6e1f247af6b6ebe/mock` // Mock
const BUSINESS_PATH_PREFIX = `/api/trade-refundbusiness/1.0.0`;

export default {
  /**
   * 退货单状态数量
   * @param {object} [params]
   * @param {string} [params.bizId] - 业务线ID
   * @param {string} [params.itemName] - 商品名称
   * @param {string} [params.applyTimeBegin] - 申请时间开始
   * @param {string} [params.applyTimeEnd] - 申请时间结束
   * @param {string} [params.refundOrderSn] - 退货退款单编号
   * @param {string} [params.returnType] - 退货类型
   */
  queryRefundCount: (params) =>
    request.get(`${BUSINESS_PATH_PREFIX}/queryB2BRefundCount`, {
      params: {
        bizId: 'B2B_SCM', // 固定
        ...params
      }
    }),

  /**
   * 退货单列表
   * @mock http://mock.qa.91jkys.com/project/199?moduleId=1303&interfaseId=10324
   * @param {object} [params]
   * @param {string} [params.bizId] - 业务线ID
   * @param {number} [params.pageNo] - 页数
   * @param {number} [params.pageSize] - 每页条数
   * @param {number} [params.refundShowStatus] - 1~9
   * @param {string} [params.itemName] - 商品名称
   * @param {string} [params.applyTimeBegin] - 申请时间开始
   * @param {string} [params.applyTimeEnd] - 申请时间结束
   * @param {string} [params.refundOrderSn] - 退货退款单编号
   * @param {string} [params.returnType] - 退货类型
   * @param {string} [params.querySn] - 订单号/退货单号
   * @param {string} [params.orderSn] - 订单编号
   * @param {string} [params.outerOrderSn] - 订单外部单号
   * @param {array} [params.userIdList] - 用户ID列表
   */
  queryRefundList: (params) =>
    request.get(`${BUSINESS_PATH_PREFIX}/queryB2BRefundList`, {
      params: {
        bizId: 'B2B_SCM', // 固定
        pageNo: 1,
        pageSize: 20,
        ...params
      }
    }),

  /**
   * 退货单详情
   * @param {object} params
   * @param {string} params.refundOrderSn - 退货单号
   */
  queryRefundDetail: (params) =>
    request.get(`${BUSINESS_PATH_PREFIX}/queryB2BRefundDetail`, {
      params: {
        bizId: 'B2B_SCM', // 固定
        ...params
      }
    }),

  /**
   * 确认收款
   * @param {object} params
   * @param {string} params.refundOrderSn - 退货单号
   */
  confirmReceiveRefund: (params) =>
    request.post(`${BUSINESS_PATH_PREFIX}/confirmReceiveRefund`, {
      bizId: 'B2B_SCM', // 固定
      ...params
    })
};
